import script from "./card-report.vue?vue&type=script&setup=true&lang=ts"
export * from "./card-report.vue?vue&type=script&setup=true&lang=ts"

import "./card-report.vue?vue&type=style&index=0&id=af821b60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af821b60"]])

export default __exports__